function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCcpa = function SvgCcpa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.253 191.925"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18471"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.321 375.556a3.357 3.357 0 0 0 3.387-2.479l-1.161-.38a2.233 2.233 0 0 1-2.226 1.646 2.706 2.706 0 0 1-.01-5.391 2.075 2.075 0 0 1 2.173 1.635l1.192-.4a3.258 3.258 0 0 0-3.366-2.427 3.747 3.747 0 0 0-3.767 3.9 3.7 3.7 0 0 0 3.778 3.896zm5.444-3.9a2.513 2.513 0 1 1 2.5 2.7 2.493 2.493 0 0 1-2.5-2.704zm-1.3 0a3.8 3.8 0 1 0 3.8-3.893 3.747 3.747 0 0 0-3.797 3.889zM381.7 375.4v-7.481h-1.72l-2.4 5.708-2.427-5.708h-1.688v7.481h1.234v-5.486l2.311 5.486h1.1l2.332-5.508v5.508zm3.144-4.041v-2.321h1.319a1.167 1.167 0 1 1 0 2.321zm1.509 1.118a2.281 2.281 0 1 0 0-4.558h-2.775v7.481h1.266v-2.923zm8.309 2.923v-1.2h-3.429v-6.278h-1.263v7.478zm2.4 0v-7.481h-1.287v7.481zm6.983 0h1.382l-2.912-7.481h-1.467l-2.912 7.481h1.34l.7-1.878h3.165zm-2.29-6.109 1.139 3.06h-2.279zm11.024 6.109v-7.481h-1.266v5.307l-3.4-5.307h-1.614v7.481h1.266v-5.666l3.693 5.666zm7.253-6.288v-1.192h-6.13v1.192h2.427v6.288h1.271v-6.29z",
    "data-name": "Path 32211",
    style: {
      fill: "#262f4d"
    },
    transform: "translate(-335.54 -183.632)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.673 358.782c7.428 0 10.6-5.064 11.378-8.373l-5.1-1.452a6.11 6.11 0 0 1-6.28 4.49 6.774 6.774 0 0 1-6.888-7.09c0-5.031 3.613-7.327 6.82-7.327 4.22 0 5.74 2.8 6.111 4.457l5.031-1.587c-.777-3.444-3.95-8.069-11.142-8.069a12.191 12.191 0 0 0-12.357 12.526 12.043 12.043 0 0 0 12.427 12.425zm24.8 0c7.428 0 10.6-5.064 11.378-8.373l-5.1-1.452a6.11 6.11 0 0 1-6.28 4.49 6.774 6.774 0 0 1-6.888-7.09c0-5.031 3.613-7.327 6.82-7.327 4.22 0 5.74 2.8 6.111 4.457l5.031-1.587c-.776-3.444-3.95-8.069-11.142-8.069a12.191 12.191 0 0 0-12.357 12.526 12.043 12.043 0 0 0 12.431 12.425zm19.132-13.708v-6.111h3.106c2.026 0 3.41 1.148 3.41 3.072 0 1.857-1.384 3.039-3.41 3.039zm3.646 4.592c4.862 0 8.2-3.14 8.2-7.664 0-4.457-3.343-7.664-8.2-7.664h-9.011v23.938h5.335v-8.61zm24.633 8.61h5.816l-8.913-23.938H419.6l-9.015 23.938h5.6l1.722-4.862h9.251zm-6.28-18 2.87 8.272h-5.807z",
    "data-name": "Path 32212",
    style: {
      fill: "#262f4d"
    },
    transform: "translate(-336.217 -185.501)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.454 233.987v-32.143h-39.006v9.309L348 223.909l4.448 4.481v12.756l8.9 8.964v4.136L369.215 267v5.515l13 16.548v13.791h14.029l21.213 12.065v9.308l30.795-4.826v-21.03L426.7 275.49h-44.848v-41.5z",
    "data-name": "Path 32243",
    style: {
      fill: "#bccaf5"
    },
    transform: "translate(-348 -201.845)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.02 285.75v-3.906H374v3.906z",
    "data-name": "Path 32244",
    style: {
      fill: "#bccaf5"
    },
    transform: "translate(-340.148 -177.686)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 294.052v-5.208h3.906v5.208z",
    "data-name": "Path 32245",
    style: {
      fill: "#bccaf5"
    },
    transform: "translate(-336.826 -175.571)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 289.75v-3.906h3.906v3.906z",
    "data-name": "Path 32246",
    style: {
      fill: "#bccaf5"
    },
    transform: "translate(-335.92 -176.477)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 234.116a2.6 2.6 0 0 1 2.6-2.6h33.852a2.6 2.6 0 0 1 2.6 2.6v23.325a2.6 2.6 0 0 1-2.6 2.6H381.6a2.6 2.6 0 0 1-2.6-2.6z",
    "data-name": "Path 32247",
    style: {
      fill: "#0068ff"
    },
    transform: "translate(-338.638 -192.886)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392.573 250.04-5.139-4.742a1.289 1.289 0 0 1 0-1.928 1.573 1.573 0 0 1 2.086-.008l.007.006 4.273 3.932 10.2-9.415a1.569 1.569 0 0 1 2.082-.007l.012.01a1.3 1.3 0 0 1 0 1.939l-11.064 10.21a1.843 1.843 0 0 1-2.445.009z",
    "data-name": "Path 32248",
    style: {
      fill: "#fff"
    },
    transform: "translate(-336.222 -191.081)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.056 235.674v-7.213a8.617 8.617 0 0 0-8.617-8.617 8.617 8.617 0 0 0-8.617 8.617v7.213",
    "data-name": "Path 32249",
    style: {
      fill: "none",
      stroke: "#0068ff",
      strokeWidth: "5.397px"
    },
    transform: "translate(-335.973 -196.409)"
  })));
};
export default SvgCcpa;